import { Button } from '@accure/ui';
import { RefreshCw } from 'lucide-react';

import { Tooltip } from '@/components/ui/tooltip';
import { ClearSystemLogsCache } from '@/system-logs/api/mutations/clear-system-logs-cache';

export function RefreshCacheButton() {
  const clearSystemLogsCache = ClearSystemLogsCache.useMutation();
  return (
    <Tooltip content="Fetch the latest log list" delay>
      <Button
        data-testid="system-logs-refresh-cache-button"
        variant="ghost"
        className="rounded-full"
        size="icon"
        onClick={() => clearSystemLogsCache.mutate()}
      >
        <RefreshCw />
      </Button>
    </Tooltip>
  );
}
